import { addNavMenuItem } from '@vendure/admin-ui/core';

export default [
    addNavMenuItem(
        {
            id: 'reviews',
            label: 'reviews.nav-label',
            routerLink: ['/extensions/reviews'],
            icon: 'star',
        },
        'marketing',
    ),
];
